module.exports = __webpack_public_path__ + "img/banner1.057e2672.png";